import { useField } from 'formik';
import React, { ReactElement } from 'react';
import CreatableSelect from 'react-select/creatable';
import { CommonProps } from 'react-select';
import isNil from 'lodash/isNil';
import { ReactSelectOption, DefaultReactSelectStyle } from './FormikReactSelect';

// Make the name required
type Props = CommonProps<ReactSelectOption> & {
  name: string;
  options: ReactSelectOption[];
  customStyles: any;
  placeholder: string;
}

export const FormikCreateableMultiSelect = (props: Props): ReactElement => {
  const { name, customStyles, placeholder } = props;
  const [field, , helpers] = useField<string[]>(name);

  const value: ReactSelectOption[] = field.value?.map(val => ({ label: val, value: val})) ?? [];
  const createableSelectStyle = {
    ...DefaultReactSelectStyle,
    ...customStyles
  }

  return (
    <CreatableSelect
      isMulti
      enableReinitialization
      styles={createableSelectStyle}
      name={name}
      value={value}
      onChange={option => {        
        if (Array.isArray(option)) {
          helpers.setValue(option.map(opt => opt.value));
        }

        if (isNil(option)) {
          helpers.setValue([]);
        }
      }}
      onBlur={field.onBlur}
      openMenuOnFocus={false}
      openMenuOnClick={false}
      arrowRenderer={null}
      components={{ DropdownIndicator:() => null, IndicatorSeparator:() => null }}
      formatCreateLabel={inputValue => `Add "${inputValue}"`}
      placeholder={placeholder}
    />
  );
}
